import React from 'react';
import { Switch, Route } from "wouter";
import Home from './pages/home.jsx';
import About from './pages/about.jsx';
import Services from './pages/services.jsx';
import Contact from './pages/contact.jsx';
import Blogs from './pages/blogs.jsx';
import Donate from './pages/donate.jsx';
import BlogDetail from './pages/BlogDetails.jsx'
import Gallery from './pages/gallery.jsx';
import Testimonial from './pages/testimonial.jsx'
import Press from './pages/press.jsx';
import Volunteer from './pages/volunteer.jsx';

import TeachersListing from './teacherslisting/pages/01_teacherslisting/01_teacherslisting.jsx';
import TeachersDetails from './teacherslisting/pages/02_teachersdetails/02_teachersdetails.jsx';
import TeachersRegistration from './teacherslisting/pages/03_teachersregistration/03_teachersregistration.jsx';

import { Toaster } from "./components/ui/toaster.tsx";
import { QueryClient, QueryClientProvider} from '@tanstack/react-query';
import { TooltipProvider } from "./components/ui/tooltip.tsx";
import AccountDeletion from './teacherslisting/pages/04_accountdeletion/04_accountdeletion.jsx';
import TermsConditions from './tcp/01_termsconditions.jsx';
import PrivacyPolicies from './tcp/02_privacypolicies.jsx';
import AccountTerms from './tcp/03_accountterms.jsx';


const queryClient = new QueryClient();

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/about" component={About} />
      <Route path="/services" component={Services} />
      <Route path="/contact" component={Contact} />
      <Route path="/blogs" component={Blogs} />
      <Route path="/donate" component={Donate} />
      <Route path="/testimonial" component={Testimonial} />
      <Route path="/press" component={Press} />
      <Route path="/volunteer" component={Volunteer} />
      <Route path="/blogs/:id" component={BlogDetail} />
      <Route path="/gallery" component={Gallery} />

      <Route path="/teachers-listing" component={TeachersListing} />
      <Route path="/teachers/:UID" component={TeachersDetails} />
      <Route path="/teachersregistration" component={TeachersRegistration} />
      <Route path="/accountdeletion" component={AccountDeletion} />

      <Route path="/terms-conditions" component={TermsConditions} />
      <Route path="/privacy-policies" component={PrivacyPolicies} />
      <Route path="/account-terms" component={AccountTerms} />
    </Switch>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Router />
    </TooltipProvider>
  </QueryClientProvider>
  );
}

export default App;